import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import FullScreenLoader from "../../components/common/FullScreenLoader";
import { useAdminAuth } from "../../context/AdminAuthContext";

const NonAuthLayout = (props) => {
  const { admin, authLoading } = useAdminAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading && admin) {
      navigate("/admin/dashboard", { replace: true });
    }
  }, [admin, authLoading, navigate]);

  if (authLoading) {
    return <FullScreenLoader />;
  }

  return <React.Fragment>{props.children}</React.Fragment>;
};

export default NonAuthLayout;
